import { Box, Button } from '@mui/material';
import TriageTable from './PatientTable';
import { useEffect, useState } from 'react';
import { TriageRegistrationConfig } from '@eql-ai/typescript-types';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers';
import { getRegistrationConfigByClientId } from 'data/registrationConfig';
import { useNavigate } from 'react-router-dom';

const PatientContainer = () => {
    const [registrationConfig, setRegistrationConfig] = useState<
        TriageRegistrationConfig | null | undefined
    >();
    const [loading, setLoading] = useState(false);

    const client = useSelector((state: RootState) => state.AuthReducer.organisation);

    const navigate = useNavigate();

    const fetchRegConfig = async () => {
        try {
            setLoading(true);

            const data = await getRegistrationConfigByClientId(client.id);

            setRegistrationConfig(data as unknown as TriageRegistrationConfig);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            await fetchRegConfig();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client.id]);

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, mb: 3 }}>
                <Button
                    onClick={() => {
                        navigate('/dashboard/access/patient/create');
                    }}
                    variant="contained"
                >
                    Add a new patient
                </Button>
                <Button
                    onClick={() => {
                        navigate('/dashboard/access/patient/upload');
                    }}
                    variant="contained"
                    sx={{ ml: 2 }}
                >
                    Import patients (csv)
                </Button>
            </Box>
            <TriageTable
                registrationConfig={registrationConfig}
                regConfigLoading={loading}
                client={client}
            />
        </Box>
    );
};

export default PatientContainer;
